"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class EvaluationRequest {
  static thaw(evaluationRequestObj) {
    if (evaluationRequestObj == null) return null;
    const evaluationRequest = new EvaluationRequest();
    if (evaluationRequestObj.id != null) evaluationRequest.setId(evaluationRequestObj.id);
    if (evaluationRequestObj.preferredSchedule != null) evaluationRequest.setPreferredSchedule(evaluationRequestObj.preferredSchedule);
    if (evaluationRequestObj.notes != null) evaluationRequest.setNotes(evaluationRequestObj.notes);
    if (evaluationRequestObj.estimatedValue != null) evaluationRequest.setEstimatedValue(evaluationRequestObj.estimatedValue);
    if (evaluationRequestObj.requestorId != null) evaluationRequest.setRequestorId(evaluationRequestObj.requestorId);
    if (evaluationRequestObj.requestorGroupId != null) evaluationRequest.setRequestorGroupId(evaluationRequestObj.requestorGroupId);
    if (evaluationRequestObj.preferredLanguageId != null) evaluationRequest.setPreferredLanguageId(evaluationRequestObj.preferredLanguageId);
    if (evaluationRequestObj.requestor != null) evaluationRequest.setRequestor(_.Person.thaw(evaluationRequestObj.requestor));
    if (evaluationRequestObj.requestorGroup != null) evaluationRequest.setRequestorGroup(_.Group.thaw(evaluationRequestObj.requestorGroup));
    if (evaluationRequestObj.preferredLanguage != null) evaluationRequest.setPreferredLanguage(_.Language.thaw(evaluationRequestObj.preferredLanguage));
    if (evaluationRequestObj.evaluationRequestEvaluees != null) evaluationRequest.setEvaluationRequestEvaluees(_.EvaluationRequestEvaluee.thawList(evaluationRequestObj.evaluationRequestEvaluees));
    if (evaluationRequestObj.evaluations != null) evaluationRequest.setEvaluations(_.Evaluation.thawList(evaluationRequestObj.evaluations));
    if (evaluationRequestObj.offers != null) evaluationRequest.setOffers(_.EvaluationRequestOffer.thawList(evaluationRequestObj.offers));
    return evaluationRequest;
  }

  static thawList(evaluationRequestObjList) {
    if (evaluationRequestObjList == null) return [];
    var evaluationRequests = [];

    for (var i = 0; i < evaluationRequestObjList.length; i++) {
      evaluationRequests.push(EvaluationRequest.thaw(evaluationRequestObjList[i]));
    }

    return evaluationRequests;
  }

  static freeze(evaluationRequest) {
    if (evaluationRequest == null) return null;
    var evaluationRequestObj = {};
    if (evaluationRequest.getId() != null) evaluationRequestObj.id = evaluationRequest.getId();
    if (evaluationRequest.getPreferredSchedule() != null) evaluationRequestObj.preferredSchedule = evaluationRequest.getPreferredSchedule();
    if (evaluationRequest.getNotes() != null) evaluationRequestObj.notes = evaluationRequest.getNotes();
    if (evaluationRequest.getEstimatedValue() != null) evaluationRequestObj.estimatedValue = evaluationRequest.getEstimatedValue();
    if (evaluationRequest.getRequestorId() != null) evaluationRequestObj.requestorId = evaluationRequest.getRequestorId();
    if (evaluationRequest.getRequestorGroupId() != null) evaluationRequestObj.requestorGroupId = evaluationRequest.getRequestorGroupId();
    if (evaluationRequest.getPreferredLanguageId() != null) evaluationRequestObj.preferredLanguageId = evaluationRequest.getPreferredLanguageId();
    if (evaluationRequest.getRequestor() != null) evaluationRequestObj.requestor = _.Person.freeze(evaluationRequest.getRequestor());
    if (evaluationRequest.getRequestorGroup() != null) evaluationRequestObj.requestorGroup = _.Group.freeze(evaluationRequest.getRequestorGroup());
    if (evaluationRequest.getPreferredLanguage() != null) evaluationRequestObj.preferredLanguage = _.Language.freeze(evaluationRequest.getPreferredLanguage());
    if (evaluationRequest.getEvaluationRequestEvaluees() != null) evaluationRequestObj.evaluationRequestEvaluees = _.EvaluationRequestEvaluee.freezeList(evaluationRequest.getEvaluationRequestEvaluees());
    if (evaluationRequest.getEvaluations() != null) evaluationRequestObj.evaluations = _.Evaluation.freezeList(evaluationRequest.getEvaluations());
    if (evaluationRequest.getOffers() != null) evaluationRequestObj.offers = _.EvaluationRequestOffer.freezeList(evaluationRequest.getOffers());
    return evaluationRequestObj;
  }

  static freezeList(evaluationRequests) {
    if (evaluationRequests == null) return [];
    var evaluationRequestObjList = [];

    for (var i = 0; i < evaluationRequests.length; i++) {
      evaluationRequestObjList.push(EvaluationRequest.freeze(evaluationRequests[i]));
    }

    return evaluationRequestObjList;
  }

  constructor() {
    this.setId(null);
    this.setPreferredSchedule(null);
    this.setNotes(null);
    this.setEstimatedValue(null);
    this.setRequestorId(null);
    this.setRequestorGroupId(null);
    this.setPreferredLanguageId(null);
    this.setRequestor(null);
    this.setRequestorGroup(null);
    this.setPreferredLanguage(null);
    this.setEvaluationRequestEvaluees(null);
    this.setEvaluations(null);
    this.setOffers(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setPreferredSchedule(preferredSchedule) {
    this.preferredSchedule = preferredSchedule;
  }

  setNotes(notes) {
    this.notes = notes;
  }

  setEstimatedValue(estimatedValue) {
    this.estimatedValue = estimatedValue;
  }

  setRequestorId(requestorId) {
    this.requestorId = requestorId;
  }

  setRequestorGroupId(requestorGroupId) {
    this.requestorGroupId = requestorGroupId;
  }

  setPreferredLanguageId(preferredLanguageId) {
    this.preferredLanguageId = preferredLanguageId;
  }

  setRequestor(requestor) {
    this.requestor = requestor;
  }

  setRequestorGroup(requestorGroup) {
    this.requestorGroup = requestorGroup;
  }

  setPreferredLanguage(preferredLanguage) {
    this.preferredLanguage = preferredLanguage;
  }

  setEvaluationRequestEvaluees(evaluationRequestEvaluees) {
    this.evaluationRequestEvaluees = evaluationRequestEvaluees;
  }

  setEvaluations(evaluations) {
    this.evaluations = evaluations;
  }

  setOffers(offers) {
    this.offers = offers;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getPreferredSchedule() {
    return this.preferredSchedule;
  }

  getNotes() {
    return this.notes;
  }

  getEstimatedValue() {
    return this.estimatedValue;
  }

  getRequestorId() {
    return this.requestorId;
  }

  getRequestorGroupId() {
    return this.requestorGroupId;
  }

  getPreferredLanguageId() {
    return this.preferredLanguageId;
  }

  getRequestor() {
    return this.requestor;
  }

  getRequestorGroup() {
    return this.requestorGroup;
  }

  getPreferredLanguage() {
    return this.preferredLanguage;
  }

  getEvaluationRequestEvaluees() {
    return this.evaluationRequestEvaluees;
  }

  getEvaluations() {
    return this.evaluations;
  }

  getOffers() {
    return this.offers;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = EvaluationRequest;